import type { Mode } from '@/types/modes.types'

export function useMode() {
  const mode = useParam<Mode>('mode', { nullValue: VEHICLE_TYPE_ALL })

  return {
    mode,
  }
}
